import { Threshold } from '../types';
import { convertTemperature, tempUnitLabel } from './temperatureUtils';

export const TEMP_THRESHOLD_TYPES = new Set([
  'temperature', 'leaf_temperature',
  'air_temperature', 'ph_temperature',
  'temp_soil1', 'temp_soil2', 'temp_soil3', 'temp_soil4',
]);

export function buildThresholdLabels(unit: string): Record<string, string> {
  const ul = tempUnitLabel(unit);
  return {
    temperature: `Temperature (${ul})`,
    electrical_conductivity: 'EC (mS/cm)',
    soil_moisture: 'Soil Moisture (%)',
    leaf_moisture: 'Leaf Moisture (%)',
    leaf_temperature: `Leaf Temperature (${ul})`,
    temp_soil1: `Probe 1 Temperature (${ul})`,
    water_soil1: 'Probe 1 Moisture (%)',
    conduct_soil1: 'Probe 1 EC (mS/cm)',
    temp_soil2: `Probe 2 Temperature (${ul})`,
    water_soil2: 'Probe 2 Moisture (%)',
    conduct_soil2: 'Probe 2 EC (mS/cm)',
    temp_soil3: `Probe 3 Temperature (${ul})`,
    water_soil3: 'Probe 3 Moisture (%)',
    conduct_soil3: 'Probe 3 EC (mS/cm)',
    temp_soil4: `Probe 4 Temperature (${ul})`,
    water_soil4: 'Probe 4 Moisture (%)',
    conduct_soil4: 'Probe 4 EC (mS/cm)',
    ph_value: 'pH',
    ph_temperature: `pH Probe Temperature (${ul})`,
    par: 'PAR (µmol/m²/s)',
  };
}

export function getThresholdConditionText(threshold: Threshold, unit: string): string {
  const { condition, min_value, max_value, threshold_type } = threshold;
  const isTemp = TEMP_THRESHOLD_TYPES.has(threshold_type);
  const fmt = (v: number | null) => {
    if (v === null) return '';
    const converted = isTemp ? convertTemperature(v, unit) : v;
    return converted != null ? converted.toFixed(1) : '';
  };
  if (condition === 'above') return `> ${fmt(min_value)}`;
  if (condition === 'below') return `< ${fmt(max_value)}`;
  return `${fmt(min_value)} – ${fmt(max_value)}`;
}
